import React from "react";
import style from "../../css/loading.module.css";

function Loading() {
  return <div className={style.container2}>Loading...</div>;
}

export default Loading;
